export default __webpack_public_path__ + "alberta-seat-shell-construction.4040f7372ab8878c0182.svg";